"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let OpenApiDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.serviceDetails = null;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/v2/reverse-proxy/services/openapi/v1/details`);
        this.serviceDetails = response.data;
        this._open_api_detail_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this._open_api_detail_dialog.hide();
    this.serviceDetails = null;
  }
};
__decorateClass([
  Ref("open-api-detail-dialog")
], OpenApiDialog.prototype, "_open_api_detail_dialog", 2);
OpenApiDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], OpenApiDialog);
export {
  OpenApiDialog as default
};
